import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import ReactPaginate from 'react-paginate';
import { Col, Row } from 'react-bootstrap';
import { allotSubscription, handleRaiserlist, removeIdenfy, removeSubscription, showToast, usTimezone, formatReferralSource, VerifyIdenfy, changeRole, deleteUsers } from '../../Utils/utils';
import moment from 'moment';
import Loaderspinner from '../../../components/Loader';
import { handleExportRaiserlist } from '../../Utils/utils';
import { Tooltip } from 'react-tooltip'
import ConfirmationModal from '../../../components/Modal/ConfirmationModal';

const BorrowerList = () => {
  const [typeStatus, setTypeStatus] = useState("");
  const [activeStatus, setActiveStatus] = useState("");
  const [raiserList, setRaiserList] = useState([]);
  const [page, setPage] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false)
  const [search, setSearch] = useState("");
  const [show, setShow] = useState(false);
  const [userId, setUserId] = useState('')
  const [selectedIds, setSelectedIds] = useState([]);
  const [showDelete, setShowDelete] = useState(false);
  const [deleteIds, setDeleteIds] = useState([]);

  const role = localStorage.getItem("role")

  useEffect(() => {
    if (search.length == 0 || search.length >= 3) {

      fetchRaisers();
    }
  }, [typeStatus, activeStatus, page, search]);

  useEffect(() => {
    setSelectedIds([]);
  }, [raiserList]);

  const toggleSelectAll = (checked) => {
    setSelectedIds(checked ? raiserList.map((raiser) => raiser.id) : []);
  };

  const toggleSelectOne = (id, checked) => {
    setSelectedIds((prev) => (checked ? [...prev, id] : prev.filter((selectedId) => selectedId !== id)));
  };

  const confirmDeleteUsers = (ids) => {
    setDeleteIds(ids);
    setShowDelete(true);
  };

  const onDeleteUsers = async () => {
    try {
      setLoading(true);
      setShowDelete(false);
      await deleteUsers(deleteIds);
      showToast('User deleted successfully', "success");
      setSelectedIds([]);
      fetchRaisers();
    } catch (error) {
      showToast(error?.message, "error");
      console.error("Error deleting users:", error);
    } finally {
      setLoading(false);
    }
  };
  const fetchRaisers = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem("token");
      const limit = 10;
      const offset = page * limit;
      const response = await handleRaiserlist({
        type: typeStatus,
        active_status: activeStatus,
        limit,
        offset,
        token, search
      });
      setRaiserList(response?.data?.rows);
      setTotalPages(response.data.count / limit)
    } catch (error) {
      console.error("Error fetching lenders:", error);
    } finally {
      setLoading(false);
    }
  };


  const ExportRaiserList = async () => {
    try {
      setLoading(true);
      const blobData = await handleExportRaiserlist({
        type: typeStatus,
        active_status: activeStatus,
      });
      // console.log(blobData, "blobData.......")
      if (blobData.size === 6506) {
        showToast("No data available for export.", "error");
        return;
      }

      const blob = new Blob([blobData], { type: "text/csv" });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "lender_list.csv");
      document.body.appendChild(link);

      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Export failed:", error);
      showToast(error.message, "error")
    } finally {
      setLoading(false);
    }
  };

  // console.log(raiserList, "raiserList....")

  const onAllotSubs = async (id) => {
    const res = await allotSubscription('BORROWER', id)
    console.log(res)
    fetchRaisers();
  }
  const onRemoveSubs = async (id) => {
    const res = await removeSubscription(id);
    console.log(res)
    fetchRaisers();
  }


  const onVerifyIdenfy = async (id) => {
    const res = await VerifyIdenfy(id)
    console.log(res)
    fetchRaisers();
  }
  const onRemoveIdenfy = async (id) => {
    const res = await removeIdenfy(id);
    console.log(res)
    fetchRaisers();
  }

  const SwitchUser = async (id) => {
    try {
      setLoading(true);
      setShow(false);
      const response = await changeRole(id, 'deal');
      if (response?.status == '200') {
        showToast('User role switched successfully', "success")
        fetchRaisers()
      } else {
        showToast(response?.message, "error")
      }
    } catch (error) {
      showToast(error?.message, "error")
      console.error("Error fetching lenders:", error);
    } finally {
      setLoading(false)
    }
  };

  return (
    <>
      {loading && <Loaderspinner />}
      <div class="g-sidenav-show  bg-gray-100 min-vh-100">
        <div id="wrapper">
          {/* <Leftbar showSidebar={showSidebar}
            handleSidebarClose={handleSidebarClose} /> */}
          <main className="main-content border-radius-lg">
            {/* <Topbar handleSidebar={handleSidebar} /> */}

            {/* <div className="header header-bg pb-6">
              <div className="container-fluid">
                <div className="header-body">
                  <div className="row align-items-center py-4">
                    <div className="col-lg-6 col-7">
                      <nav aria-label="breadcrumb" className="d-none d-md-inline-block ml-md-4">
                        <ol className="breadcrumb breadcrumb-links breadcrumb-dark" style={{ background: "transparent" }}>
                          <li className="breadcrumb-item"><Link to="/dashboard"><i className="fas fa-home" /></Link></li>
                          <li className="breadcrumb-item mt-2"><span className='' style={{ color: "#f6f9fc" }}>Borrowers</span></li>
                        </ol>
                      </nav>
                    </div>
                  </div>
                </div>
              </div>
            </div> */}
            <div className="container-fluid mt--6">
              <div className="row">
                <div className="col">
                  <div className="card">
                    <div className="card-header border-0">
                      <div className="d-flex flex-wrap justify-content-between align-items-center">
                        <div className='Table-title row'>
                          <h5 className="mb-0 w-auto">Borrowers</h5>
                          <p
                            className="w-auto px-0"
                            data-tooltip-id="my-tooltip"
                            data-tooltip-content="This list displays all registered borrowers who are creating projects and seeking funding. Operations can track borrower activity, verify profiles, and identify new funding opportunities."
                            data-tooltip-place="right"
                          >
                            <i className="fas fa-info-circle" />

                          </p>

                          <Tooltip id="my-tooltip" style={{ width: '30%' }} />
                        </div>
                        <div className="mt-3 mt-lg-0">
                          <input
                            type="text"
                            className="search-input mx-2"
                            placeholder="Search"
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                          />

                          <select
                            className="custom-select-dropdown mx-2"
                            value={typeStatus}
                            onChange={(e) => setTypeStatus(e.target.value)}
                          >
                            <option value="" className='option'>Verified Status</option>
                            <option value="verified" className='option'>Verified</option>
                            <option value="unverified" className='option'>Unverified</option>
                          </select>
                          <select
                            className="custom-select-dropdown ml-3"
                            value={activeStatus}
                            onChange={(e) => setActiveStatus(e.target.value)}
                          >
                            <option value="" className='option'>Active Status</option>
                            <option value="active" className='option'>Active</option>
                            <option value="inactive" className='option'>Inactive</option>
                          </select>
                          <button className='export-btn ml-0 ml-lg-3 mt-3 mt-lg-0 mx-2' onClick={ExportRaiserList}><span>Export Borrowers</span></button>

                          {role !== "virtual_assistant" && (
                            <button
                              className='export-btn ml-0 ml-lg-3 mt-3 mt-lg-0 mx-2'
                              style={{ backgroundColor: '#dc3545', borderColor: '#dc3545' }}
                              disabled={selectedIds.length === 0}
                              onClick={() => confirmDeleteUsers(selectedIds)}
                            >
                              <span>Delete Selected ({selectedIds.length})</span>
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="table-responsive">
                      <table className="table align-items-center table-flush">
                        <thead className="thead-light">
                          <tr>
                            {role !== "virtual_assistant" && (
                              <th>
                                <input
                                  type="checkbox"
                                  checked={raiserList.length > 0 && selectedIds.length === raiserList.length}
                                  onChange={(e) => toggleSelectAll(e.target.checked)}
                                />
                              </th>
                            )}
                            <th>Action</th>
                            <th>Name</th>
                            <th>Username</th>
                            <th>Email</th>
                            <th>Phone number</th>
                            <th>Address</th>
                            <th>Created</th>
                            <th>Heard about us</th>
                            <th>Invest Type</th>
                            <th>Invest</th>
                            <th>Last login</th>
                            <th>Verification status</th>
                          </tr>
                        </thead>
                        <tbody>
                          {raiserList.length > 0 ? (
                            raiserList.map((raiser, index) => (
                              <tr key={index}>
                                {role !== "virtual_assistant" && (
                                  <td>
                                    <input
                                      type="checkbox"
                                      checked={selectedIds.includes(raiser.id)}
                                      onChange={(e) => toggleSelectOne(raiser.id, e.target.checked)}
                                    />
                                  </td>
                                )}
                                <td>
                                  <div style={{ width: "150px" }}>
                                    <Link to={`/view-user/${raiser.id}`} target="_blank">
                                      <button className="viewproject-btn pull-right mb-1" >
                                        <span className="text-white">View User</span>
                                      </button>
                                    </Link>
                                    {role !== "virtual_assistant" &&
                                      <>
                                        {raiser.about.subscription_status === 'subscribed' ?
                                          // <Link to={`/view-user/${raiser.id}`} target="_blank">
                                          <button className="viewproject-btn-2 pull-right mb-1" onClick={() => onRemoveSubs(raiser.id)}>
                                            <span className="text-white">Remove Subscription</span>
                                          </button>
                                          // </Link>
                                          :
                                          // <Link to={`/view-user/${raiser.id}`} target="_blank">
                                          <button className="viewproject-btn pull-right mb-1" onClick={() => onAllotSubs(raiser.id)}>
                                            <span className="text-white">Allot Subscription</span>
                                          </button>
                                          // </Link>
                                        }
                                        {(raiser.about.idenfyStatus == null || raiser.about.idenfyStatus == 'REJECTED') ?
                                          // <Link to={`/view-user/${raiser.id}`} target="_blank">
                                          <button className="viewproject-btn pull-right mb-1" onClick={() => onVerifyIdenfy(raiser.id)}>
                                            <span className="text-white">Verify Idenfy</span>
                                          </button>
                                          // </Link>
                                          :
                                          (raiser.about.idenfyStatus == 'APPROVED') ?

                                            // <Link to={`/view-user/${raiser.id}`} target="_blank">
                                            <button className="viewproject-btn-2 pull-right mb-1" onClick={() => onRemoveIdenfy(raiser.id)}>
                                              <span className="text-white">Remove Idenfy</span>
                                            </button>
                                            : (raiser.about.idenfyStatus == 'PENDING') ?
                                              <>
                                                <button className="viewproject-btn pull-right mb-1" onClick={() => onVerifyIdenfy(raiser.id)}>
                                                  <span className="text-white">Verify Idenfy</span>
                                                </button>

                                                <button className="viewproject-btn-2 pull-right mb-1" onClick={() => onRemoveIdenfy(raiser.id)}>
                                                  <span className="text-white">Remove Idenfy</span>
                                                </button>
                                              </>
                                              : null
                                          // </Link>
                                        }
                                      </>
                                    }
                                    <button className="viewproject-btn-2 pull-right mb-1" onClick={() => { setShow(true); setUserId(raiser.id) }}>
                                      <span className="text-white">Switch to lender</span>
                                    </button>
                                  </div>
                                </td>
                                <td><div style={{ width: "130px" }}>{raiser?.about?.name} {raiser?.about?.lastname}</div></td>
                                <td><div style={{ width: "120px" }}>{raiser?.about?.username}</div></td>
                                <td><div style={{ width: "130px" }}>{raiser.email}</div></td>
                                <td><div style={{ width: "140px" }}>{raiser.phone}</div></td>
                                <td><div style={{ width: "140px" }}>{raiser?.about?.address}</div></td>
                                <td><div style={{ width: "140px" }}> {raiser?.created
                                  ? usTimezone(raiser.created)
                                  : ' '}</div></td>
                                <td><div style={{ width: "140px" }}>{formatReferralSource(raiser?.about)}</div></td>
                                <td>
                                  <div style={{ width: "120px" }}>
                                    {raiser?.about?.invest_type?.join(", ")}
                                  </div>
                                </td>
                                <td><div style={{ width: "120px" }}>{raiser?.about?.invest} </div></td>
                                <td><div style={{ width: "120px" }}> {raiser?.lastlogin
                                  ? usTimezone(raiser.lastlogin)
                                  : ' '}</div></td>
                                <td>
                                  {
                                    raiser?.about?.idenfyStatus === "PENDING" &&
                                    <>
                                      <div style={{ width: "120px" }} className="p-1 pendingstatus">
                                        <span>Pending</span>
                                      </div>
                                    </>
                                  }
                                  {
                                    raiser?.about?.idenfyStatus === "REJECTED" &&
                                    <>
                                      <div style={{ width: "120px" }} className="p-1 unverifiedstatus">
                                        <span>Rejected</span>
                                      </div>
                                    </>
                                  }
                                  {
                                    raiser?.about?.idenfyStatus === "APPROVED" &&
                                    <>
                                      <div style={{ width: "120px" }} className="p-1 verifiedstatus">
                                        <span>Approve</span>
                                      </div>
                                    </>
                                  }
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="14" className="text-center"><b>No records found</b></td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>


                  </div>
                  <Row>
                    <Col xs={12}>
                      {raiserList.length > 0 && (
                        <div className='paginate-css'>
                          <ReactPaginate
                            previousLabel="<"
                            nextLabel=">"
                            breakLabel="..."
                            pageCount={totalPages}
                            marginPagesDisplayed={1}
                            pageRangeDisplayed={2}
                            onPageChange={({ selected }) => setPage(selected)}
                            forcePage={page}
                            containerClassName="pagination"
                            activeClassName="active"
                            previousClassName={page === 0 ? 'disabled' : ''}
                            nextClassName={totalPages === page + 1 ? 'disabled' : ''}
                          />
                        </div>
                      )}
                    </Col>
                  </Row>
                </div>
              </div>
            </div>
          </main>
        </div>
      </div>
      <ConfirmationModal
        show={show}
        onClose={() => setShow(false)}
        onConfirm={() => SwitchUser(userId)}
        title="Change Role"
        body="Are you sure you want to switch this user role from borrower to lender?"
      />
      <ConfirmationModal
        show={showDelete}
        onClose={() => setShowDelete(false)}
        onConfirm={onDeleteUsers}
        title="Delete User"
        body={`Are you sure you want to delete ${deleteIds.length > 1 ? `these ${deleteIds.length} users` : 'this user'}? This action cannot be undone.`}
        confirmText="Delete"
      />
    </>
  )
}

export default BorrowerList;